/**
 * Returns a local uuid
 *
 * This uuid is only expected to be unique within
 * the document, not the universe.
 * @param root a prefix for the uuid
 */
export const getUid = (root?: string) => {
  const uuid = Math.random().toString(36).substring(2);

  return `${root || ""}${uuid}`;
};
